import React from "react";
import { handleError } from "../AppCommon/util";
import { CallbackComponent } from "redux-oidc";
import { withRouter } from "react-router-dom";

const CallbackPage = (props) => {
  const successCallback = (user) => {
    console.log("Success callback");
    props.history.push("/");
  };
  const errorCallback = (err) => {
    console.log("Error callback", err);
    handleError(err);
  };
  return (
    <CallbackComponent
      userManager={props.userManager}
      successCallback={successCallback}
      errorCallback={errorCallback}
    >
      <div> Redirecting...</div>
    </CallbackComponent>
  );
};

export default withRouter(CallbackPage);
